import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';
import '../Assets/Css/contact.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Container, Row, Col, Form, Button, Spinner, Card } from 'react-bootstrap';
import { IoIosSend } from 'react-icons/io';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';


import farmerImage from '../Assets/Image/farmer1.jpg';
import { Helmet } from 'react-helmet';


export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    userName: '',
    email: '',
    mobile: '',
    address: '',
     facility: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    toast.loading("Sending your message...");

    try {
      const res = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, formData);
      toast.dismiss();
      toast.success(res.data.message || "Enquiry sent!");
      setFormData({
        userName: '',
        email: '',
        mobile: '',
        address: '',
        message: '',
      });
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.error || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >

      <Helmet>
        <title>Contact Us | Hiranand Agri Solutions Pvt. Ltd.</title>
        <meta
          name="description"
          content="Get in touch with Hiranand Agri Solutions Pvt. Ltd. for product inquiries, franchise opportunities, or expert agri-consulting. We're here to support farmers across India."
        />
        <meta
          name="keywords"
          content="contact Hiranand Agri, agri solutions contact, farmer support, franchise inquiry, seed supply support, farming help, agri-tech customer service"
        />
        <meta name="author" content="Hiranand Agri Solutions Pvt. Ltd." />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Contact Us | Hiranand Agri Solutions Pvt. Ltd." />
        <meta
          property="og:description"
          content="Have a question? Reach out to Hiranand Agri Solutions for assistance with agri-products, franchise options, or technical consulting."
        />
        <meta property="og:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" />
        <meta property="og:url" content="https://hiranandagrisolutions.com/contact" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Us | Hiranand Agri Solutions Pvt. Ltd." />
        <meta
          name="twitter:description"
          content="Reach out for agri-tech support, product queries, or franchise assistance. Hiranand Agri Solutions is here to help."
        />
        <meta name="twitter:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" />

        <link rel="canonical" href="https://hiranandagrisolutions.com/contact" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <Toaster />

      <div className="banner4-section d-flex align-items-center justify-content-center">
        <div className="banner4-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">Contact Us</h2>
          <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
            Send us your inquiry — we’re happy to assist you.
          </p>
        </div>
      </div>


      {/* Contact Info Section with Floating Cards */}
      <Container className="py-5 mt-3 mb-3">
        <Row className="text-center mb-4" data-aos="zoom-in">
          <Col>
            <h3
              className="fw-bold text-center section-title"
              data-aos="fade-down"
              data-aos-delay="100"
            >
              Get in <span style={{ color: '#04A1D3' }}>Touch</span>
              <span className="title-decoration mb-2"></span>
            </h3>
          </Col>
        </Row>

        <Row className="g-4 justify-content-center align-items-stretch" data-aos="zoom-in">
          <Col md={4} sm={6} xs={12}>
            <div className="h-100">
              <Card className="mobicontactcard text-center p-4 h-100">
                <div className="icon-wrapper mb-3">
                  <FaEnvelope className="contact-icon" />
                </div>
                <h5>Email Address</h5>
                <h6 className="text-muted mb-0" style={{ fontSize: '20px' }}>
                  contact@hiranandagrisolutions.com
                </h6>
              </Card>
            </div>
          </Col>
          <Col md={4} sm={6} xs={12}>
            <div className="h-100">
              <Card className="mobicontactcard text-center p-4 h-100">
                <div className="icon-wrapper mb-3">
                  <FaPhoneAlt className="contact-icon" />
                </div>
                <h5>Mobile</h5>
                <h6 className="text-muted mb-0" style={{ fontSize: '20px' }}>
                  01169269182
                </h6>
                <h6 className="text-muted mb-0" style={{ fontSize: '20px' }}>
                  +91 7772036678
                </h6>
              </Card>
            </div>
          </Col>
          <Col md={4} sm={6} xs={12}>
            <div className="h-100">
              <Card className="mobicontactcard text-center p-4 h-100">
                <div className="icon-wrapper mb-3" style={{ fontSize: '20px' }}>
                  <FaMapMarkerAlt className="contact-icon" />
                </div>
                <h5>Location</h5>
                <h6 className="text-muted mb-0" style={{ fontSize: '20px' }}>
                  83   sudarshan nagar ab road sarangpur
                  Distt Rajgarh Madhya Pradesh Pin code 465697
                </h6>
              </Card>
            </div>
          </Col>
        </Row>

      </Container>


      <section className="py-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={10} >
              <Row className="g-0 " >
                {/* Left Image Panel */}
                


                <Col
  md={4}
  className="left-image-section d-flex align-items-center justify-content-center"
>
  <div className="image-container p-3 text-center">
    <div className="image-wrapper">
      <img
        src={farmerImage}
        alt="Farmer"
        className="img-fluid rounded-image"
      />
      <div className="contact-box">
        <span className="phone-icon">
          <FaPhoneAlt size={20} />
        </span>
        <div>
          <strong className="phone-number">7772036678</strong>
          <div className="touch-text">Get in Touch</div>
        </div>
      </div>
    </div>
  </div>
</Col>


                {/* Right Form Panel */}
                <Col md={8} className="p-5" style={{
                  backgroundColor: '#fefae0', backgroundColor: '#fefae0',
                  borderTopRightRadius: '10px',
                  borderBottomRightRadius: '10px',
                }}>

                  <h3 className="fw-bold mb-5 text-center" style={{ color: '#16343E' }}>
                    How Can We Help You?
                  </h3>

                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="formName">
                          <Form.Control
                            type="text"
                            name="userName"
                            placeholder="Your Name"
                            value={formData.userName}
                            onChange={handleChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="formEmail">
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="formMobile">
                          <Form.Control
                            type="text"
                            name="mobile"
                            placeholder="Mobile Number"
                            value={formData.mobile}
                            onChange={handleChange}
                            maxLength={10}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="formAddress">
                          <Form.Control
                            as="textarea"
                            rows={1}
                            name="address"
                            placeholder="Address"
                            value={formData.address}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="mb-4" controlId="formFacility">
    <Form.Label className="fw-bold">Select Facility</Form.Label>
    <div>
      <Form.Check
        inline
        type="radio"
        label="HASPL Agri Facility"
        name="facility"
        value="HASPL Agri Facility"
        checked={formData.facility === 'HASPL Agri Facility'}
        onChange={handleChange}
        required
      />
      <Form.Check
        inline
        type="radio"
        label="HASPL IT & Digital Services"
        name="facility"
        value="HASPL IT & Digital Services"
        checked={formData.facility === 'HASPL IT & Digital Services'}
        onChange={handleChange}
        required
      />
    </div>
  </Form.Group>

                    <Form.Group className="mb-3" controlId="formMessage">
                      <Form.Control
                        as="textarea"
                        name="message"
                        rows={4}
                        placeholder="Type your message here"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </Form.Group>

                    <div className="text-center mt-5">
                      <Button
                        variant="success"
                        className="px-4 py-2 rounded-pill"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Sending...
                          </>
                        ) : (
                          <>
                            <IoIosSend className="fs-4 me-2" />
                            Send Message
                          </>
                        )}
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>


      {/* Google Map Iframe Section */}
      <section className="map-section mt-5">
        <Container className="p-0">
          <Row className="text-center mb-4 m-0" data-aos="zoom-in">
            <Col>
              <h3 className="fw-bold section-title">Find Us on the Map
                <span className="title-decoration"> </span>
              </h3>
              <div className="section-underline mx-auto"></div>
            </Col>
          </Row>



          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.4086821386254!2d75.83756417496385!3d23.80695657864024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3965453b40a2b2d5%3A0x13e57e37082d82e3!2sHiranand%20Agri%20Solutions%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1690000000000!5m2!1sen!2sin"
            title="Hiranand Agri Solutions Pvt. Ltd."
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />


        </Container>
      </section>
    </div>
  );
}
